module.exports = __webpack_public_path__ + "img/search-dots.8eb0abd1.svg";